import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getSuppliersActionAsync } from '../redux/actions/SupplierActions'

export const useSuppliers = () => {
  const { suppliersState } = useSelector((state: RootState) => state.supplier)

  const dispatch = useDispatch()

  const getSuppliers = () => {
    dispatch(getSuppliersActionAsync())
  }

  return { suppliersState, getSuppliers }
}
